import React from 'react';

import { Container } from './styles';

const LoadingSpinner: React.FC = () => {
  return <Container />;
};

export default LoadingSpinner;
